import React, { useEffect, useState } from "react";
import * as pdfjsLib from "pdfjs-dist";

pdfjsLib.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const PdfPreviewer = ({ fileUrl }) => {
  const [pageImages, setPageImages] = useState([]);
  const [progress, setProgress] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loadingPdf, setLoadingPdf] = useState(true);

  useEffect(() => {
    let cancelled = false;
    let loadingTask = null;

    const loadPDF = async () => {
      try {
        setLoadingPdf(true);
        setPageImages([]); // reset
        setProgress(0);

        loadingTask = pdfjsLib.getDocument(fileUrl);
        const pdf = await loadingTask.promise;

        if (cancelled) return;

        setTotalPages(pdf.numPages);

        let rendered = [];

        for (let i = 1; i <= pdf.numPages; i++) {
          if (cancelled) return;

          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 3 }); // kualitas tinggi

          const canvas = document.createElement("canvas");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({
            canvasContext: canvas.getContext("2d"),
            viewport,
          }).promise;

          rendered.push(canvas.toDataURL());

          // update halaman
          setPageImages([...rendered]);

          // update progress loading
          setProgress(Math.round((i / pdf.numPages) * 100));
        }

        if (!cancelled) setLoadingPdf(false);

      } catch (err) {
        if (!cancelled) console.error("ERROR Load PDF:", err);
      }
    };

    loadPDF();

    return () => {
      cancelled = true;
      if (loadingTask && loadingTask.destroy) loadingTask.destroy();
    };
  }, [fileUrl]);

  return (
    <div style={{ flex: 1, overflowY: "auto", border: "1px solid #ddd", padding: "8px" }}>
      
      {/* LOADING UI */}
      {loadingPdf && (
        <div style={{
          textAlign: "center",
          padding: "20px",
          fontSize: "14px",
          color: "#333",
          fontWeight: "bold"
        }}>
          Loading PDF {progress}%  <small>Total Pages: {totalPages}</small>
        </div>
      )}

      {/* Pages */}
      {pageImages.map((src, idx) => (
        <img
          key={idx}
          src={src}
          alt={`page-${idx + 1}`}
          style={{
            width: "100%",
            marginBottom: "12px",
            borderRadius: "6px",
            boxShadow: "0px 1px 4px rgba(0,0,0,0.15)"
          }}
        />
      ))}
    </div>
  );
};

export default PdfPreviewer;
